import React from 'react';

export const Fingerprint = (props: { className?: string }) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={props.className}>
            <g clip-path='url(#clip0_1548_4145)'>
                <path
                    d='M9.99984 8.33317C9.55781 8.33317 9.13389 8.50877 8.82133 8.82133C8.50877 9.13389 8.33317 9.55781 8.33317 9.99984C8.33317 10.8498 8.24984 12.0915 8.1165 13.3332M11.6665 10.9332C11.6665 12.9165 11.6665 16.2498 10.8332 18.3332M14.4082 17.5165C14.5082 17.0165 14.7665 15.5998 14.8248 14.9998M1.6665 9.99984C1.6665 8.25082 2.21682 6.54613 3.23949 5.12725C4.26216 3.70837 5.70534 2.64723 7.36461 2.09414C9.02387 1.54105 10.8151 1.52406 12.4846 2.04556C14.154 2.56706 15.6171 3.60062 16.6665 4.99984M1.6665 13.3332H1.67484M18.1665 13.3332C18.3332 11.6665 18.2757 8.8715 18.1665 8.33317M4.1665 16.2498C4.58317 14.9998 4.99984 12.4998 4.99984 9.99984C4.999 9.43223 5.09481 8.86862 5.28317 8.33317M7.20817 18.3332C7.38317 17.7832 7.58317 17.2332 7.68317 16.6665M7.49984 5.6665C8.26017 5.22753 9.12268 4.99649 10.0006 4.99663C10.8786 4.99677 11.741 5.22808 12.5012 5.66731C13.2614 6.10653 13.8926 6.73817 14.3312 7.49871C14.7698 8.25926 15.0004 9.12188 14.9998 9.99984V11.6665'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_1548_4145'>
                    <rect
                        width='20'
                        height='20'
                        fill='currentColor'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Fingerprint;
